import React from 'react'

export const StatsCard = ({ title,value}) => {
    return (
        <div className="bg-secondary/20 backdrop-blur-lg text-center p-6 rounded-xl shadow-lg border border-white/20">
            <h2 className="text-tblue font-medium text-base mb-2">{title}</h2>
            <p className="text-4xl font-bold text-tblue">{value}</p>
        </div>
    )
}
